import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return {
            minutes: 15,
            seconds: 0
          };
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="flex items-end justify-center gap-4" data-id="element-24">
      <div className="flex flex-col items-center" data-id="element-25">
        <div className="text-5xl font-black font-serif leading-none" style={{
        color: '#B89555'
      }} data-id="element-26">
          {pad(timeLeft.minutes)}
        </div>
        <span className="text-xs font-bold uppercase tracking-widest mt-2" style={{
        color: '#9A9A9A'
      }} data-id="element-27">
          Minutos
        </span>
      </div>

      <div className="text-4xl font-black pb-5" style={{
      color: 'rgba(200,169,106,0.5)'
    }} data-id="element-28">
        :
      </div>

      <div className="flex flex-col items-center" data-id="element-29">
        <div className="text-5xl font-black font-serif leading-none" style={{
        color: '#B89555'
      }} data-id="element-30">
          {pad(timeLeft.seconds)}
        </div>
        <span className="text-xs font-bold uppercase tracking-widest mt-2" style={{
        color: '#9A9A9A'
      }} data-id="element-31">
          Segundos
        </span>
      </div>
    </div>;
}